<section id="content" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.viewCustomer }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id">{{lang.viewCustomer }}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data.code }} / {{ single_data.bussines_name }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <!-- <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a> -->

            <a class="plus-edit" [routerLink]="['/'+AppFrontRoutes.EDIT_CUSTOMER+'/'+this.id]"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">General Data</a></li>

                  <li role="presentation" [ngClass]="{ 'active':operatingTab==='activeTab'}"><a href="#operating"
                      aria-controls="operating" role="tab" data-toggle="tab">{{
                      lang.operatingLocations }}</a></li>


                  <li role="presentation"><a href="#employee" aria-controls="employee" role="tab"
                      data-toggle="tab">Incoming Requirements</a></li>


                  <li role="presentation"><a href="#projectPhase" aria-controls="projectPhase" role="tab"
                      data-toggle="tab">Project Phase</a></li>

                  <li role="presentation"><a href="#academy" aria-controls="academy" role="tab"
                      data-toggle="tab">Document</a></li>

                  <li role="presentation"><a href="#protocol" aria-controls="protocol" role="tab"
                      data-toggle="tab">Protocol</a></li>
                </ul>

                <div class="tab-content">

                  <ejs-gantt id="GanttSample" 
                  [dataSource]="data1" 
                  height= "450px"
                  width="800px"
                  [taskFields]= "taskfield">
                </ejs-gantt>
                
                  <div role="tabpanel" class="tab-pane" id="generalTab">
                   

                  </div>


                  <div role="tabpanel" class="tab-pane" id="projectPhase">
                   
                  

                  </div>

                  <div role="tabpanel" class="tab-pane" id="protocol">
                    <div class="row p-10">
                      <div class="col-sm-9">
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport5"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableImport5" data-action="show"
                          data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
                          title="Import">
                          <span class="glyphicon glyphicon-import"></span>
                        </a>

                        <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete_protocol()"
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Delete">
                          <span class="glyphicon glyphicon-trash"></span>
                        </a>

                        </div>
                      </div>


                      <div class="col-sm-3" style="float: right;">
                        <div class="social-icons">
                          <a class="plus-add" (click)="add_protocol()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <button class="btn btn-success"><i class="fa fa-plus"></i>Add Protocol</button>
                          </a>
                        </div>
                      </div>


                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions5" class="table-striped table-sm row-border hover"
                        id="table5" *ngIf="protocol">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>No.</th>
                            <th>{{ plang?.projectCode }}</th>
                            <th>{{ plang?.type }}</th>
                            <th>{{ plang?.topic }}</th>
                            <th>{{ plang?.description }}</th>
                            <th>{{ plang?.date }}</th>
                            <th>{{ plang?.addresser }}</th>
                            <th>{{ plang?.addressee }}</th>
                            <th>{{ plang?.attachments }}</th>
                            <th>{{ plang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let precord of protocol let j = index" id="{{ precord.id }}">
                            <td>{{ j + 1 }}</td>
                            <td></td>
                            <td>{{ j + 1 }}</td>
                            <td>{{ precord.code }}</td>
                            <td>{{ precord.type }}</td>
                            <td>{{ precord.title }}</td>
                            <td>{{ precord.desp }}</td>
                            <td>{{ precord.date_doc }}</td>
                            <td>{{ precord.add1 }}</td>
                            <td>{{ precord.add2 }}</td>
                            <td>
                              <div *ngFor='let attach of precord.attachments.split(",")'>
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/project/{{attach}}"
                                  target="_blank">{{attach}}</a>
                              </div>
                            </td>
                            <td>
                              <div class="btn-group dropup">


                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete_protocol(precord.id,this.pid)"><i
                                        class="fa fa-trash"></i> {{ plang.erase }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="editProtocol(precord.id,this.pid)"><i class="fa fa-edit"></i>
                                      {{ plang.modify }}</a></li>
                                  <li><a (click)="viewProtocol(precord.id,this.pid)"
                                      class="view_action"><i class="glyphicon glyphicon-eye-open"></i>
                                      {{plang.view}}</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>





                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ ollang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ ollang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ ollang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ ollang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ emplang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ emplang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ emplang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_customers_employees.csv">Click
                  Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ clang?.export }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <!-- <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
                (change)="export3_select_deselect_all($event)"><i></i> {{ clang?.selectAll }} </label> -->
        </div>
        <div class="row flexs">

          <div class="active-left">
            <!-- <h2>{{ clang?.activeColumns }}</h2> -->

            <!-- <div class="row" *ngFor="let option of datatableCols3">
                <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                  <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                    (change)="export3_select_deselect($event)"><i></i> {{option.value}}
                </label>
              </div> -->
            <div id="datatableExportBtn3" class="export_dynamic_btn">


            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="export_dynamic_btn">
          </div>
          <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ alang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ alang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport5" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_customers_employees.csv">Click
                  Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>